export const colors = {
  primary: '#445D74',
  text: '#283845',
  textSecondary: '#64748B',
  textTertiary: '#94A3B8',
  bodyBackground: 'linear-gradient(180deg, #FDFBF6 0%, #CCD6E0 100%)',
  error: '#DC2626',
  success: '#15803D',

  coldCharcoal300: '#829CB2',
  coldCharcoal400: '#51708B',
  coldCharcoal500: '#48637B',

  buttonHover: '#1F7ACE',
  buttonColor: '#fff',
  buttonDisabled: '#576fcc',
  buttonDisabledTextColor: '#c6c6c6',
  optionActive: '#1B2128',
  optionInactive: '#1B2128',
  optionBorderActive: '#FFBA00',
  optionBorderInactive: '#3C404D',
  optionCheckActive: '#FFBA00',
  optionCheckInactive: '#3C404D',
  optionActiveText: '#fff',
  inputBg: 'rgba(255, 255, 255, 0.10)',
  reviewItemBg: '#1B2128',
  progressBarActive: '#244BD5',
  progressBarBg: '#1A233D',
  planItemBg: '#ffffff1a',
  planItemBorder: '#afa9bf',
  planItemCheckBorder: '#AEAEB4',
} as const

export const breakpoints = {
  tablet: 768,
  desktop: 1200,
} as const

export type ThemeColors = typeof colors
export type ThemeBreakpoints = typeof breakpoints
export interface ThemeType {
  colors: ThemeColors
  breakpoints: ThemeBreakpoints
  isRtl?: boolean
}

export const theme = {
  colors,
  breakpoints,
  maxContentWidth: '360',
}

export { GlobalStyles } from './GlobalStyles'
